import Cookies from 'js-cookie'

const urls = JSON.parse(document.body.dataset.urls)

const csrftoken = Cookies.get('csrftoken')
$.ajaxSetup({
  beforeSend: function (xhr, settings) {
    xhr.setRequestHeader('X-CSRFToken', csrftoken)
  }
})

/**
 * @legacy
 * @prev administration/templates/administration/account/job_list.html
 */
$('.disable-job').change(function () {
  var job_id = $(this).attr('data-job-id')
  $.ajax({
    url: urls.job_status,
    type: 'POST',
    data: { job_id: job_id }
  })
})

/**
 * @legacy
 * @prev administration/templates/administration/account/service_list.html
 */
$('.disable-service').change(function () {
  var service_id = $(this).attr('data-service-id')
  $.ajax({
    url: urls.service_status,
    type: 'POST',
    data: { service_id: service_id }
  })
})
